<template>
  <div>
    <v-card>
      <!-- Toolbar. -->
      <v-toolbar dense color="primary" dark align="center">
        <!-- Titolo. -->
        <v-toolbar-title>Gestione Header</v-toolbar-title>
        <v-spacer />

        <!-- Pulsante aggiungi modulo. -->
        <v-tooltip v-if="nuovo_modulo == false" bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              light
              v-on="on"
              @click="
                nuovo_modulo = true;
                modulo = '';
                getColonne();
              "
            >
              <v-icon color="primary"> mdi-table-plus </v-icon>
            </v-btn>
          </template>
          <span>Nuovo modulo per header</span>
        </v-tooltip>

        <!-- Annulla aggiungi modulo. -->
        <v-tooltip v-if="nuovo_modulo == true" bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              light
              v-on="on"
              @click="
                nuovo_modulo = false;
                modulo = '';
                getColonne();
              "
            >
              <v-icon color="primary"> mdi-table </v-icon>
            </v-btn>
          </template>
          <span>Elenco moduli già presenti</span>
        </v-tooltip>

        <!-- Pulsante aggiungi colonna. -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="addColumn" small light class="ml-5">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Nuova Colonna</span>
        </v-tooltip>

        <!-- Pulsante salvataggio. -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="saveImpostazioni" small light class="ml-5">
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>

        <v-spacer />

        <!-- Pulsante indietro. -->
        <v-btn small light @click="$router.push('/home/amministrazione')">
          <v-icon color="error">mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row align="center" justify="center">
          <!-- Lista moduli. -->
          <v-col cols="6" v-if="nuovo_modulo == false">
            <v-autocomplete
              background-color="#ffffff"
              hide-details
              :items="lista_moduli"
              item-text="modulo"
              label="Modulo per header"
              item-value="modulo"
              v-model="modulo"
              @change="
                getColonne();
                assegnaTabellaModulo();
                $emit('send_modulo', modulo);
              "
            >
            </v-autocomplete>
          </v-col>

          <!-- Se nuovo modulo, v-textfield per inserire il nome. -->
          <v-col v-else cols="6">
            <v-text-field
              hide-details
              v-model="modulo"
              type="text"
              label="Inserire nome nuovo modulo per header"
            >
            </v-text-field>
          </v-col>

          <!-- Inserimento nome tabella. -->
          <v-col cols="3">
            <v-text-field
              hide-details
              type="text"
              label="Tabella"
              v-model="modulo_tabella"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <!-- Tabella lista header. -->
        <v-data-table :headers="headers" :items="lista_header">
          <template v-slot:[`item.text`]="{ item }">
            <v-text-field dense required v-model="item.text"></v-text-field>
          </template>
          <template v-slot:[`item.tipo_oggetto`]="{ item }">
            <v-autocomplete dense
              :items="items_tipi_oggetto"
              item-text="des"
              item-value="val_txt"
              required
              v-model="item.tipo_oggetto"
            >
              <template #label>
                <span class="">Tipo Oggetto</span>
                <a @click.stop style="pointer-events: all">
                  <Modules
                    v-on:dialogModules="getTabelle"
                    tipo="TIPO_OGGETTO_HEADER"
                    nome="Tipo Oggetto"
                    setaction="settabelle"
                    getaction="gettabelle"
                    controller="Magazzino"
                    filter="validita = 1"
                    :dati="[{ des: '' }]"
                  />
                </a>
              </template>
            </v-autocomplete>
          </template>
          <template v-slot:[`item.value`]="{ item }">
            <v-text-field dense required v-model="item.value"></v-text-field>
          </template>
          <template v-slot:[`item.fields`]="{ item }">
            <v-text-field dense v-model="item.fields"></v-text-field>
          </template>
          <template v-slot:[`item.tipo_valore`]="{ item }">
            <v-text-field dense v-model="item.tipo_valore"></v-text-field>
          </template>
          <template v-slot:[`item.join_fields`]="{ item }">
            <v-text-field dense v-model="item.join_fields"></v-text-field>
          </template>

          <!-- Pulsante visibilità. -->
          <template v-slot:[`item.visible`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">

                <v-btn small v-if="item.visible == 1" v-bind="attrs" v-on="on"
                  @click="item.visible = 0">
                  <v-icon color="primary">mdi-eye</v-icon>
                </v-btn>

                <v-btn small v-else v-bind="attrs" v-on="on"
                  @click="item.visible = 1">
                  <v-icon color="error">mdi-eye-off</v-icon>
                </v-btn>
              </template>
              <span>{{ item.visible == 0 ? "Invisibile" : "Visibile" }}</span>
            </v-tooltip>
          </template>

          <!-- Checkbox per indicare header ordinabile. -->
          <template v-slot:[`item.sortable`]="{ item }">
            <v-checkbox
              :false-value="0"
              :true-value="1"
              v-model="item.sortable"
            ></v-checkbox>
          </template>

          <template v-slot:[`item.ordine`]="{ item }">
            <v-text-field dense
              required
              v-model="item.ordine"
              type="number"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Snackbar. -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay caricamento. -->
    <v-overlay color="rgba(0, 0, 0, 1)" style="position: absolute" :value="caricamento_dati_dialog > 0">
      <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
      <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "GestioneHeader",
  components: {
    SnackbarQV,
    Modules: () => import("@/components/TOOLS/Modules"),
  },
  data() {
    return {
      modulo: "",
      modulo_tabella: "",
      modulo_tabella_selez: null,
      nuovo_modulo: false,
      caricamento_dati_dialog: 0,

      headers: [
        { text: "Testo", value: "text" },
        { text: "Tipo Oggetto", value: "tipo_oggetto" },
        { text: "Valore", value: "value" },
        { text: "Campi", value: "fields" },
        { text: "Campi join", value: "join_fields" },
        { text: "Tipo valore", value: "tipo_valore" },
        { text: "Ordine", value: "ordine", width: "80px" },
        { text: "Ordinabile", value: "sortable", width: "150px" },
        { text: "Visibilità", value: "visible", width: "100px", sortable: false },
      ],
      items_tipi_oggetto: [],
      lista_header: [],
      lista_moduli: [],
      lista_moduli_tabelle: [],
    };
  },

  mounted() {
    this.getListaModuli();
    this.getTabelle();
  },

  methods: {
    addColumn() {
      // Controllo che l'utente abbia selezionato un modulo.
      if (this.modulo == "" || this.modulo == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare un modulo prima di aggiungere un nuovo elemento."
        );
        return;
      }

      this.lista_header.push({
        id_header: -1,
        modulo: this.modulo,
        text: "",
        tipo_oggetto: null,
        value: "",
        fields: "",
        join_fields: "",
        ordine: this.lista_header[this.lista_header.length - 1] + 1,
        visible: 1,
      });
    },

    assegnaTabellaModulo() {
      this.modulo_tabella = null;
      this.modulo_tabella_selez = null;

      // Se la "m.des" corrisponde al nome del modulo selezionato, assegna la tabella salvata.
      this.lista_moduli_tabelle.forEach((m) => {
        if (m.des === this.modulo) {
          this.modulo_tabella = m.val_txt;
          this.modulo_tabella_selez = m;
        }
      });
    },

    getColonne() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getheader",
          token: localStorage.getItem("user_token"),
          nome_modulo: this.modulo,
          default: "true",
          tipo2: "",
          filter: "validita = 1",
        },
      };

      this.caricamento_dati_dialog ++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati_dialog --;
          this.lista_header = res.data;
        })
        .catch((err) => {
          this.caricamento_dati_dialog --;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },

    getListaModuli() {
      var request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getmoduliheader",
          token: localStorage.getItem("user_token"),
        },
      };

      this.caricamento_dati_dialog ++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati_dialog --;
          if (res.status == 200) {
            this.lista_moduli = res.data.result ? res.data.result : [];
          }
        })
        .catch((err) => {
          this.caricamento_dati_dialog --;
          console.log("Errore:");
          console.log(err);
        });
    },

    getTabelle() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "'TIPO_OGGETTO_HEADER','TABELLA_MODULO_HEADER'",
          filter: "validita = 1",
        },
      };

     this.caricamento_dati_dialog ++;

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati_dialog --;
          if (res.status === 200) {
            this.items_tipi_oggetto = res.data.TIPO_OGGETTO_HEADER
              ? res.data.TIPO_OGGETTO_HEADER
              : new Array();
            this.lista_moduli_tabelle = res.data.TABELLA_MODULO_HEADER
              ? res.data.TABELLA_MODULO_HEADER
              : new Array();
            this.assegnaTabellaModulo();
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.caricamento_dati_dialog --;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },

    // Salva in "Tabella" il nome della tabella dell'header.
    setModuloTabella() {
      let tmp_tabella;
      if (this.modulo_tabella_selez) {
        this.modulo_tabella_selez.val_txt = this.modulo_tabella;
        tmp_tabella = this.modulo_tabella_selez;
      } else {
        if (!this.modulo_tabella) return;
        tmp_tabella = {
          id_tabella: -1,
          tipo: "TABELLA_MODULO_HEADER",
          des: this.modulo,
          val_txt: this.modulo_tabella,
        };
      }

      let request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "settabella",
          token: localStorage.user_token,
          id_utente: localStorage.id,
          tabella: [tmp_tabella],
        },
      };
      this.caricamento_dati_dialog ++;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati_dialog --;
          console.log(res.status);
        })
        .catch((err) => {
          this.caricamento_dati_dialog --;
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },

    saveImpostazioni() {
      if (this.modulo) this.setModuloTabella();

      this.lista_header.forEach((h) => {
        h.modulo = this.modulo;
      });
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setheader",
          header: this.lista_header,
          token: localStorage.getItem("user_token"),
          super_user: 1,
        },
      };

      this.caricamento_dati_dialog ++;

      this.$store.dispatch("api", request).then((res) => {
        this.caricamento_dati_dialog --;
        if (res.status == 200) {
          this.getColonne();
          this.getTabelle();
          this.$refs.SnackbarQV.print("success", "Salvataggio effettuato.");
        } else {
          this.$refs.SnackbarQV.print("error", "Errore nel salvataggio.");
        }
      })
      .catch((e) => {
        this.caricamento_dati_dialog --;
        this.$refs.SnackbarQV.print("error", "Errore di comunicazione: " + e);
      });
    },
  },

  watch: {
    modulo_tabella: {
      immediate: true,
      handler() {
        this.$emit("send_tabella", this.modulo_tabella);
      }
    },

    caricamento_dati: {
      immediate: true,
      handler() {
        this.caricamento_dati = this.caricamento_dati < 0 ? 0 : this.caricamento_dati;
      },
    },
  },
  
};
</script>

<style scoped>
/* Overlay */
@keyframes ConsuntivoWOControtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ConsuntivoWORotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ConsuntivoWOControruota {
  animation: ConsuntivoWOControtazione 1s infinite;
  animation-timing-function: linear;
}

.ConsuntivoWORuota {
  animation: ConsuntivoWORotazione 1s infinite;
  animation-timing-function: linear;
}
/* *** */
</style>